import React from "react";

export const ExcelIcon = (props: any) => {
  return (
    <svg
      width={props.size ?? 19}
      height={props.size ?? 20}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9065_23740)">
        <path
          d="M17.9077 2.7843H11.3984V4.90432H13.5518V6.34727H11.3984V7.75754H13.5298V9.17846H11.3984V10.5994H13.5298V12.0203H11.3984V13.4412H13.5298V14.8622H11.3984V16.9935H17.9077C18.2352 16.9935 18.5031 16.7158 18.5031 16.3754V3.4024C18.5031 3.06209 18.2352 2.7843 17.9077 2.7843ZM17.0821 14.8622H14.2403V13.4412H17.0821V14.8622ZM17.0821 12.0203H14.2403V10.5994H17.0821V12.0203ZM17.0821 9.17846H14.2403V7.75754H17.0821V9.17846ZM17.0821 6.33661H14.2403V4.91569H17.0821V6.33661Z"
          fill={props.color ?? "#4CAF50"}
        />
        <path
          d="M0.03125 2.70536V17.073L10.6882 19.1248V0.652832L0.03125 2.70536ZM6.77211 13.498L5.53236 11.1542C5.48547 11.0668 5.43716 10.9062 5.38671 10.6725H5.36753C5.34408 10.7826 5.28867 10.9503 5.20128 11.1748L3.95726 13.498H2.02552L4.31889 9.9002L2.22089 6.30172H4.19314L5.22189 8.45939C5.30217 8.6299 5.37392 8.83238 5.43787 9.06612H5.45776C5.49825 8.92545 5.57356 8.71658 5.68369 8.43878L6.82753 6.301H8.63352L6.47585 9.86894L8.69391 13.4973L6.77211 13.498Z"
          fill={props.color ?? "#4CAF50"}
        />
      </g>
      <defs>
        <clipPath id="clip0_9065_23740">
          <rect
            width="18.472"
            height="18.472"
            fill="white"
            transform="translate(0.0322266 0.652832)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
